








































import Vue from 'vue'
import ModalPanel from '../atoms/ModalPanel.vue'

export type DataType = {
  showContent: boolean
}
export default Vue.extend({
  components: {
    ModalPanel
  },
  data(): DataType {
    return {
      showContent: false
    }
  },
  computed:{
    envCheckUrl() {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/device/`
    }
  },
  methods: {
    openModal(): void {
      this.showContent = true
      document.getElementsByTagName('html')[0].style.overflow = "hidden";
    },
    closeModal(): void {
      this.showContent = false
      document.getElementsByTagName('html')[0].style.overflow = "scroll";
    }
  }
})
